module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921092649_T.956bb8e6.jpg";